export default {
    setSelectedArchiveProject(state, project) {
        state.selectedArchiveProject = project
    },
    setQueryData(state, queryData) {
        state.searchQueryData = queryData
    },
    setSelectedStatusDataBySite(state, statusData) {
        state.statusDataBySite = statusData
    },
    setProjectRules(state, rules) {
        state.allRules = rules
    },
    setAppliedProjectRule(state, rule) {
        state.appliedProjectRule = rule
    },
    setAppliedSiteRules(state, rules) {
        state.appliedSiteRules = rules
    },
    setAppliedDeviceRules(state, rules) {
        state.appliedDeviceRules = rules
    }
}
